import XLSX from 'xlsx-js-style';

export const removeNewLineCharacters = <T>(value: T): T => {
  if (typeof value !== 'string') {
    return value;
  }
  return value.replace(/(\r\n|\n|\r)/gm, '') as T;
};

export function parseXLSXSheet<T>({
  sheet,
  columnNames,
  defaultValue,
  rejectBlanks = false,
  removeNewLines = false,
}: {
  sheet: XLSX.WorkSheet;
  columnNames?: string[];
  defaultValue?: any;
  rejectBlanks?: boolean;
  removeNewLines?: boolean;
}): { rows: T[]; headers: string[]; types: string[] } {
  let rows: T[] = [];

  type DataRow = [];

  const data = XLSX.utils.sheet_to_json<DataRow>(sheet, {
    header: 1,
    defval: defaultValue,
  });

  const [headers, types = []] = data;

  rows = XLSX.utils.sheet_to_json<T>(sheet, {
    header: columnNames || headers,
    range: 1,
    defval: defaultValue,
  });

  rows = rows
    .filter((row: any) => {
      if (!rejectBlanks) {
        return row;
      }
      // reject rows that have more than a quarter of the columns blank (or 2 columns if its a very small import)
      // this is to avoid any whitespace characters being interpreted as data and causing issues
      const usedColumns = Object.values(row)?.length;
      return usedColumns > Math.max(headers.length / 4, 2);
    })
    .map((row: any) => {
      const newRow: any = {};
      Object.keys(row).forEach((prop) => {
        try {
          if (!removeNewLines) {
            newRow[prop] =
              typeof row[prop] === 'string' ? row[prop].trim() : row[prop];
          }
          //remove new line characters from the property name
          const propCleaned = removeNewLineCharacters(prop).trim();

          if (typeof row[prop] === 'string') {
            //remove new line characters from the value
            newRow[propCleaned] = removeNewLineCharacters(row[prop].trim());

            // if its just an empty string, set it to undefined
            if (newRow[propCleaned] === '') {
              newRow[propCleaned] = defaultValue ?? undefined;
            }

            // COMMENTED OUT AS TURNS STRINGS INTO NUMBER WHICH ISN'T ALWAYS DESIRED
            // FOR EXAMPLE IMPORTING BARCODES THAT START WITH ZEROS REMOVES THE ZEROS
            //handle if the string is actually a number
            // if (isNumeric(newRow[propCleaned])) {
            // newRow[propCleaned] = Number(newRow[propCleaned]);
            // }
          } else {
            newRow[propCleaned] = row[prop];
          }
        } catch (err) {
          console.error(err);
        }
      });

      return newRow;
    });

  const rowTypes = types?.map((value) => typeof value);

  return { rows, headers, types: rowTypes };
}
